/*=============================================== Container component ===============================================*/

import classNames from "classnames"

import { Footer } from "../Footer"
import { NavBottom } from "../NavBottom"

import {
    StyledContainer,
    StyledWrapper,
} from "components/layouts/Container/styles"
import type { ContainerProps } from "components/layouts/Container/types"

const Container = ({ children, isNavOpen }: ContainerProps) => {
    return (
        <StyledWrapper className={classNames({ "nav-open": isNavOpen })}>
            <StyledContainer size="large" minHeight="calc(100vh - 64px)">
                {children}
            </StyledContainer>

            <NavBottom />

            <Footer />
        </StyledWrapper>
    )
}

export default Container
